import React from "react";
import { MonitorCog, X } from "lucide-react";

const TerminalFormModal = ({ form, setForm, onClose, onSubmit }) => {
  return (
    <>
   
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 montserrat-font-1">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-6 animate-scaleIn">
        {/* HEADER */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
              <MonitorCog size={21} className="text-green-600" />
              Add New Terminal
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Create a new POS terminal for this restaurant.
            </p>
          </div>

          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full border hover:bg-gray-100"
          >
            <X size={18} />
          </button>
        </div>

        {/* FORM */}
        <div className="space-y-5">
          <div>
            <label className="text-sm text-gray-600">Terminal Name</label>

            <input
              type="text"
              value={form.terminalname}
              onChange={(e) =>
                setForm({
                  ...form,
                  terminalname: e.target.value,
                })
              }
              className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
              placeholder="Example: Terminal POS-01"
            />
          </div>

          <div>
            <label className="text-sm text-gray-600">Terminal Code</label>

            <input
              type="text"
              value={form.terminalcode}
              onChange={(e) =>
                setForm({
                  ...form,
                  terminalcode: e.target.value,
                })
              }
              className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
              placeholder="Example: POS-01"
            />
          </div>

          <div>
            <label className="text-sm text-gray-600">Device ID</label>

            <input
              type="text"
              value={form.deviceid}
              onChange={(e) =>
                setForm({
                  ...form,
                  deviceid: e.target.value,
                })
              }
              className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
              placeholder="Example: Admin_1"
            />
          </div>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 mt-7">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={onSubmit}
            className="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-600 text-white font-medium"
          >
            Save Terminal
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default TerminalFormModal;